// Generated by npm run generate-i18n-catalogs. Do not edit directly.

export const catalogDe = {
  "controls": {
    "boot": "Starten",
    "reset": "Reset",
    "copyScreen": "Bildkopie",
    "copyText": "Text Kopieren",
    "pasteText": "Einfügen",
    "saveState": "Speichern",
    "restoreState": "Laden",
    "toggleSound": "Ton Umschalten",
    "settings": "Einstellungen",
    "debugPanel": "Debug-Panel",
    "infoPanel": "Informationsbereich",
    "reportIssue": "Ein Problem melden",
    "privacyPolicy": "Datenschutzrichtlinie"
  },
  "config": {
    "speed": "Geschwindigkeit",
    "display": "Anzeigeeinstellungen",
    "theme": "Design",
    "openRetroControlPanel": "Bedienfeld",
    "resetSettings": "Alle Einstellungen Zurücksetzen",
    "capsLock": "Feststelltaste",
    "useOpenApple": "{{modKey}}-Taste als Open Apple-Taste verwenden",
    "useShortcuts": "{{modKey}}-Taste für Tastaturkürzel verwenden",
    "useArrowKeys": "Pfeiltasten als Joystick Verwenden",
    "scanlines": "CRT-Scanlinien",
    "ghosting": "Phosphor-Nachleuchten",
    "crtDistortion": "CRT-Verzerrung",
    "joystick": "Joystick-Konfiguration"
  },
  "machine": {
    "configuration": "Maschinenkonfiguration",
    "slotConfigurator": "Erweiterungssteckplätze"
  },
  "speed": {
    "snail": "Schneckentempo (0.1 MHz)",
    "slow": "Langsam (0.5 MHz)",
    "normal": "Normal (1 MHz)",
    "fast": "Schnell (4 MHz)",
    "warp": "Wahnsinnige Geschwindigkeit"
  },
  "colors": {
    "color": "Farbe",
    "nofringe": "Farbe (ohne Fransen)",
    "green": "Grün",
    "amber": "Bernstein",
    "white": "Schwarz und Weiß",
    "inverse": "Schwarz und Weiß (Umgekehrt)"
  },
  "themes": {
    "classic": "Klassisch",
    "dark": "Dunkel"
  },
  "debug": {
    "helpPanel": "Hilfe-Panel anzeigen",
    "debugPanel": "Debug-Panel anzeigen",
    "expectinPanel": "Apple exPectin-Panel anzeigen",
    "helpTab": "Hilfe",
    "debugTab": "Fehlersuche",
    "breakpoints": "Haltepunkte",
    "memory": "Arbeitsspeicher",
    "stack": "Stapel",
    "state": "CPU-Zustand",
    "registers": "Register",
    "step": "Schritt",
    "stepOver": "Schritt Über",
    "stepInto": "Schritt Hinein",
    "stepOut": "Schritt Heraus",
    "resume": "Fortsetzen",
    "loadSymbolTable": "Symboltabelle laden",
    "disassembly": "Disassemblierung"
  },
  "tour": {
    "welcome": "Willkommen zum Apple2TS-Emulator!",
    "clickNext": "Um mehr zu erfahren, drücken Sie die Weiter-Taste.",
    "bootButton": "Hier klicken, um den Emulator zu starten.",
    "resetButton": "Hier klicken, um den Apple II zurückzusetzen und entweder neu zu starten oder BASIC zu betreten.",
    "diskImages": "Wählen Sie eines der installierten Disk-Images aus.",
    "floppyDisks": "Oder klicken Sie auf eines der Disketten-Symbole, um ein Disk-Image zu laden.",
    "saveRestore": "Sie können den kompletten Zustand des Emulators mit diesen Tasten speichern und wiederherstellen.",
    "themeButton": "Hier klicken, um das Emulator-UI-Design zu ändern.",
    "endTour": "Sie haben das Ende der Tour erreicht. Klicken Sie auf die Globus-Tour-Taste, um eine der anderen Touren auszuprobieren, oder drücken Sie Beenden, um den Emulator zu verwenden.",
    "tourSelectorHint": "Klicken Sie auf die Globus-Tour-Schaltfläche, um eine der anderen Touren auszuprobieren, oder drücken Sie auf Fertig stellen, um den Emulator zu verwenden.",
    "settingsWelcome": "Apple2TS hat eine vollständige Sammlung von Steuerelementen sowohl für den Emulator als auch für den Apple II. Um mehr zu erfahren, drücken Sie die Weiter-Taste.",
    "mainControls": "Hier können Sie den Apple II starten und zurücksetzen, den Zustand wiederherstellen und speichern, den Bildschirm kopieren oder Text in den Emulator einfügen.",
    "snapshot": "Sie können jederzeit einen Schnappschuss des aktuellen Emulator-Zustands machen, dann in der Zeit zu einem früheren Zustand zurückkehren oder wieder vorspulen. Sie können auch den Emulator-Zustand mit allen aktuellen Schnappschüssen speichern.",
    "pauseButton": "Sie können den Emulator jederzeit pausieren und den 6502-Prozessor einfrieren. Dies ist nützlich, um die Aktion in einem Spiel zu pausieren oder den Debugger zu betreten.",
    "debugButton": "Klicken Sie auf den Käfer, um in den Debug-Modus zu wechseln, wo Sie den internen Zustand des 6502-Prozessors sehen können. Klicken Sie erneut, um zum normalen Modus zurückzukehren.",
    "configButtons": "Die untere Reihe von Tasten steuert den Zustand des Apple II, beginnend mit der Emulator-Geschwindigkeit, der Bildschirmfarbe und der Stummschaltung des Tons.",
    "keyboardButtons": "Wenn die Feststelltaste eingeschaltet ist, sind alle getippten Zeichen GROSSBUCHSTABEN.",
    "altArrowKeys": "Die nächste Taste bestimmt, ob die {{modKey}}-Taste für Tastaturkürzel oder die Apple II Open Apple-Taste verwendet wird. Die letzte Taste bestimmt, ob die Pfeiltasten als Apple II-Joystick verwendet werden können.",
    "clearCookies": "Apple2TS speichert automatisch die aktuellen Emulator-Einstellungen als Browser-Cookies. Drücken Sie diese Taste, um diese Einstellungen zurückzusetzen und die Cookies zu löschen.",
    "debugWelcome": "Apple2TS hat eine reichhaltige Sammlung von Werkzeugen zur Analyse und zum Debugging von 6502-Assemblercode. Um mehr zu erfahren, drücken Sie die Weiter-Taste.",
    "debugIcon": "Klicken Sie auf das Käfer-Symbol in den Info-Tabs, um das Debug-Panel anzuzeigen.",
    "debugPause": "Drücken Sie die Pause-Taste, um die Ausführung des Emulators zu pausieren oder fortzusetzen.",
    "debugControls": "Nachdem wir pausiert haben, können wir mit den Tasten Schritt Über, Hinein und Heraus durch den disassemblierten Code gehen. Wir können auch schnell zur aktuellen Adresse des Programmzählers (PC) springen.",
    "debugDisassembly": "Hier sehen wir den disassemblierten Code mit den Hex-Adressen, der dreistufigen Anweisung und allen Werten oder Adressen. Wenn Sie die Maus über einen grünen Wert bewegen, erscheint ein Tooltip mit dem aktuellen Wert. Ein Klick auf eine blaue Adresse scrollt zu diesem Ort. Sie können auch im linken Rand klicken, um Haltepunkte hinzuzufügen oder zu entfernen.",
    "debugInfo": "In der Mitte haben wir den Stapel-Dump und eine Speicherkarte. Die Speicherkarte aktualisiert sich in Echtzeit und zeigt Ihnen, welche Speicherbänke derzeit aktiv sind.",
    "debugMemory": "Der letzte Abschnitt zeigt den Apple II-Speicher. Sie können die Dropdown-Liste verwenden, um verschiedene Teile des Speichers zu untersuchen. Wenn Sie zu einer der HGR-Seiten wechseln, erhalten Sie eine vergrößerte Ansicht des Hi-Res-Bildschirms, die mit den Speicherorten verknüpft ist. Sie können auch nach Hex-Werten oder ASCII-Strings suchen und den Speicher in einer Datei speichern.",
    "back": "Zurück",
    "close": "Schließen",
    "last": "Beenden",
    "next": "Weiter",
    "nextLabelWithProgress": "Weiter (Schritt {step} von {steps})",
    "skip": "Schließen",
    "guidedTour": "Geführte Tour",
    "mainLabel": "Geführte Tour: Hauptmenü",
    "settingsLabel": "Geführte Tour: Einstellungen",
    "debugLabel": "Geführte Tour: Debugging"
  },
  "disk": {
    "drive1": "Laufwerk 1",
    "drive2": "Laufwerk 2",
    "hardDisk": "Festplatte",
    "eject": "Diskette Auswerfen",
    "insert": "Diskette Einlegen",
    "writeProtected": "Schreibgeschützt",
    "readWrite": "Lesen/Schreiben",
    "empty": "Leer",
    "loading": "Laden...",
    "selectDisk": "Disk-Image Auswählen",
    "browse": "Durchsuchen",
    "newReleases": "Neue Veröffentlichungen",
    "writeProtectDisk": "Disk Schreibschutz",
    "saveDiskToDevice": "Disk speichern",
    "saveDiskTo": "Disk speichern auf",
    "saveDiskToMenu": "Disk speichern auf >",
    "addToFavorites": "Zu Favoriten hinzufügen",
    "downloadDisk": "Disk herunterladen",
    "downloadWoz": "WOZ-Disk-Image herunterladen",
    "downloadAndEjectDisk": "Disk herunterladen und auswerfen",
    "ejectDisk": "Disk auswerfen",
    "ejectAllDisks": "Alle Disks auswerfen",
    "saveDiskToOneDrive": "Disk auf OneDrive speichern",
    "saveDiskToGoogleDrive": "Disk auf Google Drive speichern",
    "loadDisk": "Disk laden",
    "loadAdditionalDisks": "Weitere Disk laden...",
    "loadDiskFrom": "Disk laden von",
    "loadDiskFromMenu": "Disk laden von >",
    "loadDiskFromDevice": "Disk laden",
    "loadDiskFromDeviceReadOnly": "Disk vom Gerät laden (Nur Lesen)",
    "loadDiskFromDeviceReadWrite": "Disk vom Gerät laden (Lesen/Schreiben)",
    "loadDiskFromInternetArchive": "Disk von Internet Archive laden",
    "loadDiskFromOneDrive": "Disk von OneDrive laden",
    "loadDiskFromGoogleDrive": "Disk von Google Drive laden",
    "insertBlankDisk": "Leere Diskette einlegen",
    "syncEveryMinute": "Jede Minute synchronisieren",
    "syncEvery5Minutes": "Alle 5 Minuten synchronisieren",
    "pauseSyncing": "Synchronisation pausieren",
    "syncNow": "Jetzt synchronisieren",
    "modified": "geändert",
    "synced": "synchronisiert",
    "diskImage": "Disk-Image",
    "diskDrivesAndDevices": "Diskettenlaufwerke und Geräte",
    "syncedAt": "Synchronisiert {{date}}",
    "clickToLoadDiskImage": "Klicken Sie hier, um das Disk-Image (die Disk-Images) zu laden",
    "clickToRemoveFromDiskCollection": "Klicken Sie hier, um aus der Disk-Sammlung zu entfernen",
    "clickToAddToDiskCollection": "Klicken Sie hier, um zur Disk-Sammlung hinzuzufügen",
    "byCreator": "von {{creator}}",
    "clickToViewDetails": "Klicken Sie hier, um Details anzuzeigen",
    "standbyDisks": "Bereitstehende Disketten (Klicken zum Wechseln der Diskette)"
  },
  "help": {
    "title": "Apple2TS",
    "subtitle": "Apple IIe Emulator in TypeScript",
    "credit": "(c) {{year}} Chris Torrence und die Mitwirkenden von Apple2TS",
    "keyboardShortcuts": "Tastaturkürzel",
    "shortcutsUnavailable": "Die Emulator-Tastaturkürzel mit {{keyMod}} sind nicht verfügbar, solange diese Taste als Open Apple verwendet wird. Mit Strg+0 bis Strg+5 lässt sich die Emulatorgeschwindigkeit weiterhin auswählen.",
    "diskImages": "Disk-Images:",
    "diskContainers": "Komprimierte Archive:",
    "multiDiskNotice": "Mehrfach-Diskettenwechsel: Klicken Sie auf die Multi-Disk-Plakette, um das Schnellwechselmenü zu öffnen. Multi-Disk-Archive (.zip, .7z, .gz) werden automatisch in die Wechselliste geladen.",
    "urlParameters": "Optionale URL-Parameter",
    "examples": "Beispiele",
    "mobileInstructions": "Mobile Plattformen:",
    "tapScreen": "Tippen Sie auf den Bildschirm, um die Tastatur anzuzeigen.",
    "arrowKeys": "Drücken Sie die Pfeiltasten, Esc oder Tab-Tasten, um diese Tasten an den Emulator zu senden.",
    "ctrlKey": "Um ein Steuerzeichen zu senden, drücken Sie einmal die Ctrl-Taste. Tippen Sie dann auf den Bildschirm, um die Tastatur anzuzeigen, und drücken Sie die gewünschte Taste. Die Ctrl-Taste wird automatisch losgelassen.",
    "ctrlLock": "Um mehrere Steuerzeichen zu senden, drücken Sie die Ctrl-Taste zweimal, um sie zu verriegeln (angezeigt durch einen grünen Punkt). Tippen Sie dann auf den Bildschirm, um die Tastatur anzuzeigen, und drücken Sie die gewünschten Tasten. Drücken Sie die Ctrl-Taste erneut, um sie zu lösen.",
    "appleKeys": "Die Open Apple- und Closed Apple-Tasten verhalten sich wie die Ctrl-Taste.",
    "openAppleKey": "Open Apple: Linke Alt/Option drücken",
    "closedAppleKey": "Closed Apple: Rechte Alt/Option drücken",
    "joystickKeys": "Joystick-Tasten: Ziffernblock 8/2/4/6 (7/9/1/3), 0/5, ./Eingabe",
    "onScreenKeyboard": "Für die Bildschirmtastatur, um CTRL oder ESC zu verwenden:\nEinmal drücken zum Aktivieren, dann die gewünschte Taste.",
    "urlParametersBody": "Für optionale URL-Parameter fügen Sie diese nach einem Fragezeichen (?) an die URL an und trennen Sie mehrere Parameter mit einem Kaufmanns-Und (&). Verwenden Sie # um das Disk-Image anzugeben. Beispiele finden Sie im Link-Builder-Dialog.",
    "exampleLinks": {
      "totalReplayDebugging": "Total Replay mit Debugging",
      "totalReplayChoplifter": "Total Replay, Choplifter laden, eingebetteter Modus",
      "a2Desktop": "A2DeskTop 2MG mit schneller Geschwindigkeit und Farbe",
      "embeddedBasic": "Eingebettetes Applesoft BASIC-Programm",
      "binaryHexAddress": "Binärdatei mit Hex-Adresse"
    },
    "resourceLinks": {
      "desktopApp": "Apple2TS Desktop-App",
      "corsProxy": "CORS Proxy by Corsfix",
      "silverCjkFont": "Silver CJK Pixel Font"
    }
  },
  "messages": {
    "loading": "Laden...",
    "error": "Fehler",
    "success": "Erfolg",
    "confirm": "Bestätigen",
    "cancel": "Abbrechen",
    "on": "ein",
    "off": "aus",
    "confirmTheme": "Den Emulator neu laden und dieses Design jetzt anwenden?",
    "confirmReset": "Alle Einstellungen auf Standardwerte zurücksetzen?",
    "fileNotFound": "Datei nicht gefunden",
    "invalidFile": "Ungültiges Dateiformat",
    "diskInserted": "Diskette eingelegt",
    "diskEjected": "Diskette ausgeworfen"
  },
  "keyboard": {
    "capsLock": "Feststelltaste",
    "shift": "Umschalt",
    "ctrl": "Strg",
    "enter": "Eingabe",
    "space": "Leertaste",
    "backspace": "Rücktaste",
    "delete": "Entfernen"
  },
  "audio": {
    "speaker": "Lautsprecher",
    "midi": "MIDI",
    "configuration": "Audio-Konfiguration",
    "volume": "Lautstärke",
    "mute": "Stumm",
    "waveform": "Wellenform"
  },
  "print": {
    "printer": "Drucker",
    "print": "Drucken",
    "clear": "Löschen",
    "save": "Ausgabe Speichern",
    "dumpScreen": "Aktuellen Bildschirm auf Drucker ausgeben",
    "dumpScreenInverse": "Aktuellen Bildschirm ausgeben (Invertiert)",
    "sendToPrinter": "An Drucker senden",
    "tearOff": "Seite abreißen und zurücksetzen",
    "printedPage": "Gedruckte Seite",
    "printerConfig": "Druckerkonfiguration",
    "pageLength": "Seitenlänge",
    "pageLengthLetter": "11 Zoll (Letter)",
    "pageLengthA4": "11,7 Zoll (A4)",
    "pageLengthTwelve": "12 Zoll"
  },
  "device": {
    "machineConfiguration": "Maschinenkonfiguration",
    "midiDeviceSelect": "MIDI-Geräteauswahl",
    "serialPortSelect": "Serielle Portauswahl",
    "mockingboardWaveform": "Mockingboard-Wellenform"
  },
  "collection": {
    "showApple2TSCollection": "Apple2TS-Sammlung anzeigen",
    "showNewReleases": "Neue Veröffentlichungen anzeigen",
    "showFavorites": "Favoriten anzeigen",
    "chooseDiskImage": "Disk-Image wählen",
    "diskCollection": "Disk-Sammlung",
    "clickToShowDetails": "Klicken um Details anzuzeigen für",
    "clickToLoadDisk": "Klicken um Disk zu laden",
    "diskIsNewRelease": "Disk ist eine neue Veröffentlichung",
    "diskIsApple2TSCollection": "Disk ist Teil der Apple2TS-Sammlung",
    "diskIsInternetArchive": "Disk ist Teil des Internet Archive",
    "clickToRemoveFromCollection": "Klicken um aus Disk-Sammlung zu entfernen",
    "clickToAddToCollection": "Klicken um zur Disk-Sammlung hinzuzufügen",
    "diskIsSyncedVia": "Disk wird synchronisiert über",
    "loadDiskIntoDrive": "Disk in Laufwerk laden",
    "exportDisksToHdv": "Disks als HDV exportieren",
    "export": "Exportieren",
    "clickToRemoveFromSelected": "Klicken um aus Auswahl zu entfernen",
    "clickToAddToSelected": "Klicken um zur Auswahl hinzuzufügen",
    "reportExportIssue": "Exportproblem melden"
  },
  "debugControls": {
    "goBackInTime": "Zurückspulen",
    "takeSnapshot": "Schnappschuss erstellen",
    "goForwardInTime": "Vorspulen",
    "saveStateWithSnapshots": "Zustand mit Schnappschüssen speichern",
    "resume": "Fortsetzen",
    "pause": "Pausieren",
    "tracing": "Tracing läuft",
    "downloadTraceLog": "Trace-Log herunterladen"
  },
  "fullscreen": {
    "fullScreen": "Vollbild"
  },
  "internetArchive": {
    "searchPlaceholder": "Geben Sie den Namen eines Softwaretitels ein oder klicken Sie auf eine der Kategorien oben",
    "go": "LOS"
  },
  "basic": {
    "newProgram": "Neues Programm",
    "runFromBeginning": "Von Anfang an ausführen",
    "break": "Unterbrechen",
    "continueRunning": "Ausführung fortsetzen",
    "stepProgram": "Programm in Einzelschritten ausführen",
    "resumeOutput": "Ausgabe fortsetzen",
    "freezeOutput": "Ausgabe einfrieren",
    "importProgram": "Programm importieren...",
    "exportProgram": "Programm exportieren...",
    "renumberProgram": "Programm neu nummerieren",
    "rebuildProgram": "Programm aus dem Speicher wiederherstellen",
    "displaySettings": "Anzeigeeinstellungen",
    "autoLineNumbering": "Automatische Zeilennummerierung",
    "capitalizeKeywords": "Schlüsselwörter großschreiben",
    "rebuildWarning": "Dadurch wird das aktuelle Programm durch eine aus dem Apple II-Speicher wiederhergestellte Version ersetzt. Nicht gespeicherte Änderungen gehen verloren. Sind Sie sicher?",
    "value": "Wert"
  },
  "expectin": {
    "runScript": "Skript ausführen",
    "stopScript": "Skript stoppen"
  },
  "saveDisassembly": {
    "title": "Disassemblierung speichern",
    "startAddress": "Startadresse $",
    "endAddress": "Endadresse $",
    "includeLabels": "Symbolbezeichnungen einschließen",
    "separatorLines": "Trennlinien nach JMP, RTS"
  },
  "gamepad": {
    "useArrowKeys": "Pfeiltasten als Joystick",
    "siriusJoyport": "Sirius Joyport-Modus"
  },
  "traceSettings": {
    "title": "Trace-Einstellungen",
    "settings": "Einstellungen"
  },
  "linkBuilder": {
    "startupOptionsTab": "Startoptionen",
    "speedNames": {
      "warp": "Wahnsinnig"
    },
    "ramDiskSizes": {
      "512": "512",
      "1024": "1024",
      "4096": "4096",
      "8192": "8192"
    },
    "slots": {
      "configure": "Steckplatzkarten konfigurieren",
      "slot": "Slot {{slot}}:",
      "cardNone": "Keine (leer)"
    },
    "additionalDiskDrives": "Zusätzliche Diskettenlaufwerke",
    "slot6Drive1": "Steckplatz 6 Laufwerk 1 (Diskette 1)",
    "slot6Drive2": "Steckplatz 6 Laufwerk 2 (Diskette 2)",
    "slot7Drive1": "Steckplatz 7 Laufwerk 1 (Festplatte 1)",
    "slot7Drive2": "Steckplatz 7 Laufwerk 2 (Festplatte 2)",
    "slot2Drive1": "Steckplatz 2 Laufwerk 1 (VERA SD)",
    "slot4Drive1": "Steckplatz 4 Laufwerk 1 (VERA SD)",
    "addAdditionalDisk": "Zusätzliche Diskette zum Wechseln hinzufügen",
    "removeDisk": "Diese Diskette entfernen",
    "addAnotherDisk": "Weitere Diskette hinzufügen",
    "diskPlaceholder": "Diskette {num} Dateiname (z. B. sideB.woz|Szenario-Diskette)"
  },
  "startup": {
    "welcome": "Willkommen bei Apple2TS",
    "copyright": "(c) {{year}} C.Torrence + Mitarbeiter",
    "diskCollections": "Auf die Disk-Sammlung klicken\num ein Spiel zu laden."
  },
  "retroControl": {
    "machine": "Maschine",
    "fullscreen": "Vollbild",
    "diskCollection": "Disketten",
    "diskDrives": "Laufwerke",
    "display": "Anzeige",
    "monitorMode": "Monitormodus",
    "monitorModeChoice": {
      "ntsc": "NTSC",
      "rgb": "RGB"
    },
    "sound": "Ton",
    "options": "Optionen",
    "skin": "Oberfläche",
    "personalization": "Personalisierung",
    "text": "Text",
    "background": "Hintergrund",
    "border": "Rahmen",
    "iigsColor": {
      "black": "Schwarz",
      "red": "Rot",
      "darkBlue": "Dunkelblau",
      "purple": "Violett",
      "darkGreen": "Dunkelgrün",
      "darkGray": "Dunkelgrau",
      "mediumBlue": "Mittelblau",
      "lightBlue": "Hellblau",
      "brown": "Braun",
      "orange": "Orange",
      "lightGray": "Hellgrau",
      "pink": "Rosa",
      "lightGreen": "Hellgrün",
      "yellow": "Gelb",
      "aquamarine": "Aquamarin",
      "white": "Weiß"
    },
    "keyboard": "Tastatur",
    "joystick": "Joystick",
    "slots": "Steckplätze",
    "devices": "Geräte",
    "printerPort": "Druckeranschluss",
    "modemPort": "Modemanschluss",
    "quit": "Beenden",
    "apple2tsCollection": "Apple2TS-Sammlung",
    "newReleases": "Neuerscheinungen",
    "favorites": "Favoriten",
    "exportDisksToHdv": "Disks als HDV exportieren",
    "noDiskDrivesAvailable": "Keine Laufwerke verfügbar",
    "select": "Auswählen",
    "open": "Öffnen",
    "load": "Laden",
    "go": "Los",
    "save": "Speichern",
    "clipboard": "Zwischenablage",
    "cancelEsc": "Abbrechen:Esc",
    "color": "Farbe",
    "systemSpeed": "Systemgeschwindigkeit",
    "other": "Sonstiges",
    "timeMachine": "Schnappschüsse",
    "ports": "Anschlüsse",
    "language": "Sprache",
    "retroTheme": "Retro",
    "lowercaseInput": "Kleinbuchstabeneingabe",
    "openAppleKey": "Open-Apple-Taste",
    "sortOrder": "Sortierung",
    "card": {
      "empty": "Leer",
      "mockingboard": "Mockingboard"
    }
  }
}
